import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  private readonly baseUrl = `${environment.baseUrl}`;

  constructor(private http: HttpClient) {}

  protected get<T>(endpointUrl: string): Observable<T> {
    return this.http.get<Response<T>>(`${this.baseUrl}${endpointUrl}`, {}).pipe(
      map((response) => {
        return response.result;
      })
      //catchError(this.handleError)
    );
  }

  protected getBlob(endpointUrl: string): Observable<ArrayBuffer> {
    let options = {
      observe: 'body' as 'body',
      responseType: 'arraybuffer' as 'json',
    };
    return this.http.get<ArrayBuffer>(`${this.baseUrl}${endpointUrl}`, options);
  }

  protected getAttachmentFromBlobURL(endpointUrl: string): Observable<any> {
    let options = {
      responseType: 'blob' as 'json',
    };
    return this.http.get<any>(`${endpointUrl}`, options);
  }

  protected getNew<T>(endpointUrl: string, params: HttpParams): Observable<T> {
    return this.http
      .get<Response<T>>(`${this.baseUrl}${endpointUrl}`, { params: params })
      .pipe(
        map((response) => {
          return response.result;
        })
        //catchError(this.handleError)
      );
  }

  protected post<T>(endpointUrl: string, object: any): Observable<T> {
    return this.http
      .post<Response<T>>(`${this.baseUrl}${endpointUrl}`, object)
      .pipe(
        map((response) => {
          return response.result;
        }),
        catchError(this.handleError)
      );
  }

  protected postTest<T>(endpointUrl: string, object: any) {
    this.http
      .post<Response<T>>(`${this.baseUrl}${endpointUrl}`, object)
      .subscribe({
        next: (data) => {},
        error: (error) => {},
      });
  }

  protected put<T>(endpointUrl: string, object: any): Observable<T> {
    return this.http
      .put<Response<T>>(`${this.baseUrl}${endpointUrl}`, object)
      .pipe(
        map((response) => {
          return response.result;
        })
        //catchError(this.handleError)
      );
  }

  protected patch<T>(endpointUrl: string, object: any): Observable<T> {
    return this.http
      .patch<Response<T>>(`${this.baseUrl}${endpointUrl}`, object)
      .pipe(
        map((response) => {
          return response.result;
        }),
        catchError(this.handleError)
      );
  }

  protected delete<T>(endpointUrl: string, object: any): Observable<T> {
    const options = {
      body: object,
    };
    return this.http
      .delete<Response<T>>(`${this.baseUrl}${endpointUrl}`, options)
      .pipe(
        map((response) => {
          return response.result;
        })
        //catchError(this.handleError)
      );
  }

  private handleError(err: any): Observable<never> {
    return throwError(() => err.error.errorMessage);
  }

  public get loggedUserData(): string {
    let item = JSON.parse(
      sessionStorage.getItem('0-144e251b-30ff-4027-be96-0623e40cbc19')
    );
    return item.userData.sub;
  }

  protected queryParams(params: object) {
    var queryParams = '';
    var count = 0;
    for (var name in params) {
      if (params[name]) {
        if (count === 0) queryParams += '?';
        else queryParams += '&';
        queryParams += `${name}=${params[name]}`;
        count++;
      }
    }
    return queryParams;
  }
}

export interface Response<T> {
  result: T;
  errorMessage: string;
  timeGenerated: Date;
  success: boolean;
}
